module.exports = __webpack_public_path__ + "img/fresher.705dee58.svg";